import emailjs from '@emailjs/browser';
import { MapPin, Mail, Phone } from 'lucide-react'
import React from 'react'
import { useState } from 'react'
import { toast } from 'react-toastify';
import 'flag-icons/css/flag-icons.min.css';

export default function Contact() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const submit = (e) => {
        e.preventDefault();

        const serviceid = 'service_sda7rh7';
        const templateid = 'template_zhm5sa7';
        const publickey = 'QDCWT0tCFgA952S0Y';

        const contactdata = {
            name: name,
            from_email: email,
            subject: subject,
            message: message,
        }

        emailjs.send(serviceid, templateid, contactdata, publickey)
            .then((response) => {
                toast.success("email sent successfully")
                setEmail('')
                setSubject('')
                setMessage('')
                setName('')
            })
            .catch((error) => {
                toast.error("Error sending email", error)
            })

        console.log(name, email, subject, message);
        setEmail('')
        setName('')
        setMessage('')
        setSubject('')
    }

    return (
        <section id='contact' className='w-full py-20 bg-gradient-to-br from-gray-50 to-blue-50'>
            <div className="bl-container">
                {/* Header */}
                <div className="text-center mb-16">
                    <h2 className='text-4xl md:text-5xl font-bold text-gray-900 mb-4'>
                        Contact Us
                    </h2>
                    <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Ready to start your next project? Get in touch with our team
                    </p>
                </div>

                <div className='grid lg:grid-cols-2 gap-12 items-start'>
                    {/* Contact Information */}
                    <div className='space-y-8'>
                        <div>
                            <h3 className='text-3xl font-bold text-gray-900 mb-4'>Get in Touch</h3>
                            <p className='text-lg text-gray-600 leading-relaxed'>
                                Have questions about our services? We'd love to hear from you.
                                Send us a message and we'll respond as soon as possible.
                            </p>
                        </div>

                        {/* Contact Cards */}
                        <div className='space-y-6'>
                            {/* Email */}
                            <div className='group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1'>
                                <div className='flex items-start gap-4'>
                                    <div className='p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors duration-300'>
                                        <Mail size={24} className='text-blue-600' />
                                    </div>
                                    <div>
                                        <h4 className='text-xl font-semibold text-gray-900 mb-2'>Email</h4>
                                        <a href='mailto:Application@rtventure.net'
                                            className='text-gray-600 hover:text-blue-600 transition-colors duration-300 font-medium'>
                                            Application@rtventure.net
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* Phone */}
                            <div className='group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1'>
                                <div className='flex items-start gap-4'>
                                    <div className='p-3 bg-green-50 rounded-lg group-hover:bg-green-100 transition-colors duration-300'>
                                        <Phone size={24} className='text-green-600' />
                                    </div>
                                    <div>
                                        <h4 className='text-xl font-semibold text-gray-900 mb-2'>Phone Number</h4>
                                        <div className='space-y-1'>
                                            <a href='tel:977-9709742080'
                                                className='block text-gray-600 hover:text-green-600 transition-colors duration-300 font-medium'>
                                                {/* <span className='text-sm text-gray-500'>Nepal: </span>977-9709742080 */}
                                            </a>
                                            <a href='tel:+1- 210 448 1184'
                                                className='block text-gray-600 hover:text-green-600 transition-colors duration-300 font-medium'>
                                                <span className='text-sm text-gray-500'>USA: </span>+1-210-448-1184
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Address */}
                            <div className='group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1'>
                                <div className='flex items-start gap-4'>
                                    <div className='p-3 bg-purple-50 rounded-lg group-hover:bg-purple-100 transition-colors duration-300'>
                                        <MapPin size={24} className='text-purple-600' />
                                    </div>
                                    <div>
                                        <h4 className='text-xl font-semibold text-gray-900 mb-2'>Address</h4>
                                        <div className='space-y-1'>

                                            <a href='https://www.google.com/maps/place/Dallas, Texas'
                                                target='_blank'
                                                rel="noreferrer"
                                                className=' text-gray-600 hover:text-purple-600 transition-colors duration-300 font-medium flex items-center gap-2'>
                                                <h1> Dallas, Texas, USA</h1>
                                                <span className='fi fi-us' size={20} ></span>

                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className='bg-white p-8 rounded-2xl shadow-xl border border-gray-100'>
                        <h3 className='text-2xl font-bold text-gray-900 mb-6'>Send us a message</h3>
                        <form onSubmit={submit} className='space-y-6'>
                            <div className='space-y-2'>
                                <label htmlFor="name" className='block font-semibold text-gray-700'>Name</label>
                                <input
                                    id="name"
                                    value={name}
                                    type="text"
                                    placeholder='Your full name'
                                    className='w-full border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-lg rounded-lg p-3 transition-all duration-300'
                                    required
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className='space-y-2'>
                                <label htmlFor="email" className='block font-semibold text-gray-700'>Email</label>
                                <input
                                    id="email"
                                    value={email}
                                    type="email"
                                    placeholder='your@email.com'
                                    className='w-full border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-lg rounded-lg p-3 transition-all duration-300'
                                    required
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className='space-y-2'>
                                <label htmlFor="subject" className='block font-semibold text-gray-700'>Subject</label>
                                <input
                                    id="subject"
                                    value={subject}
                                    type="text"
                                    placeholder='What is this about?'
                                    className='w-full border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-lg rounded-lg p-3 transition-all duration-300'
                                    required
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </div>
                            <div className='space-y-2'>
                                <label htmlFor="message" className='block font-semibold text-gray-700'>Message</label>
                                <textarea
                                    id="message"
                                    value={message}
                                    rows={5}
                                    placeholder='Tell us more about your project...'
                                    className='w-full border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-lg rounded-lg p-3 transition-all duration-300 resize-none'
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                            </div>
                            <button
                                type='submit'
                                className='w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg py-4 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg'
                            >
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}